<template>
<v-card>
  <v-card-title class='subtitle-1 overline py-1 grey lighten-4' >
    Generate report
    <v-spacer/>
    <v-btn @click='$emit("close")' small icon >
      <v-icon small >close</v-icon>
    </v-btn>
  </v-card-title>
  <v-divider />
  <v-alert type='info' :value='true' class='mt-0' >
    This will load a print friendly report which you can either print, or save as a pdf.

    <li><strong>To print</strong>: In your browser, click file -> print (or cmd/ctrl P)</li>
    <li><strong>To save as PDF</strong>: From the print dialog, select save as PDF as your destination</li>
  </v-alert>
  <v-card-text>
    <v-text-field v-if='withTitle' v-model='title' label='Title' />

    <v-layout>
      <v-spacer/>
      <v-btn v-if='withDates' small outline
        @click='withDates=false;fromDate=null;toDate=null;' >Clear date range
        <v-icon small class='ml-2' >cancel</v-icon>
      </v-btn>
      <v-btn v-else small outline
        @click='withDates=true' >Add date range</v-btn>
    </v-layout>

    <v-layout v-if='withDates' >

      <v-flex xs6 >
        <v-subheader class='overline' >From date</v-subheader>
        <v-date-picker no-title v-model='fromDate' :max='toDate' full-width type='month' class='elevation-0' />
      </v-flex>
      <v-divider vertical />
      <v-flex xs6>
        <v-subheader class='overline' >To date</v-subheader>
        <v-date-picker no-title v-model='toDate' :min='fromDate' full-width type='month' class='elevation-0' />
      </v-flex>

    </v-layout>
    <!-- {{reportUrl}} -->
  </v-card-text>
  <v-card-actions>
    <v-btn @click="$emit('close')" flat >Cancel</v-btn>
    <v-spacer/>
    <v-btn color='primary' target='_blank' :href='reportUrl' >
      Show report
      <v-icon class='ml-2' small >open_in_new</v-icon>
    </v-btn>
  </v-card-actions>
</v-card>
</template>
<script>
export default {
  name: 'ReportForm',
  props: {
    reportName: { type: String },
    relationshipId: { required: true }
  },
  data () {
    return {
      title: null,
      fromDate: null,
      toDate: null,
      withDates: true,
      withTitle: false
    }
  },
  watch: {
    reportName: {
      immediate: true,
      handler () {
        if (this.reportName === 'account') {
          this.withTitle = true
          this.title = 'Account summary'
        } else {
          this.withTitle = false
        }
      }
    }
  },
  computed: {
    reportUrl () {
      let path = '/reports/' + this.reportName + '/' + this.relationshipId + '/'
      let url = this.$appointmentguru.baseUrl + path
      let params = []
      if (this.fromDate && this.toDate) {
        params.push('start=' + this.fromDate + '-01')
        params.push('end=' + this.toDate + '-25')
      }
      if (this.title) {
        params.push('report_title=' + this.title)
      }
      if (params.length > 0) {
        let str = params.join('&')
        url = url + '?' + str
      }
      return url
    }
  }
}
</script>



// WEBPACK FOOTER //
// ReportForm.vue?3efa4a77